import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import router from "@/router";
import {errorHandler} from "@/services/errorHandler";
import auth from "@/store/modules/auth";

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        url: null,
    },
    getters: {
        getURl: (state) => {
            return state.url?state.url:JSON.parse(localStorage.getItem('url'));
        },
    },
    mutations: {
        setURl: (state, url) => {
            localStorage.setItem('url', JSON.stringify(url));
            state.url = url
        },
    },
    actions: {
        createTransaction: (context, payload) => {
            return axios.post(gateway + 'GateWay/CreateTransaction', payload)
                .then(async ({data}) => {
                    context.commit('setURl', data.url);
                }).catch((err) => errorHandler.tomcatError(err));
        },
        getBranches: (context) => {
            const apiKey = context.getters.getApi;
            return axios.get(gateway + `branches?apikey=${apiKey}`)
                .then(async ({data}) => {
                    return data;
                }).catch((err) => errorHandler.tomcatError(err));
        },
    },
    modules: {
        auth,
    }
})
export default store;

